/* eslint-disable no-dupe-keys */
export default {
  service_provider_withdraw_application_statistics: {
    name: '运营商提现月统计',
    // 属性（一般与对象内容匹配）
    prop: {
      // 统计
      applied_time_range: '申请时间范围',
      service_provider: '运营商',
      ev_charging_station: '充电站',
      bank_account_name: '银行卡户名',
      bank_account_number: '银行卡账号',
      bank_name: '开户行',
      total_amount: '合计金额（元）',
      station_amount: '站金额（元）',
      charge_station_total_amount: '站金额（元）',
      total_amount: '合计金额（元）',
      total_untransferred_amount: '未转账金额（元）',
      latest_created_at: '最后提现申请时间'
    },
    labels: {
      total_amount: '总金额',
      untransfer_amount: '未转账金额',
      transferred_amount: '已转账金额',
      total_stations_count: '总充电站转账数',
      transferred_stations_count: '已完全转账充电站数',
      untransfer_stations_count: '未完全转账充电站数'
    }
  }
}
